<template>
    <div class='login-box'>
        <div class="login-box-logo">
            <img src='https://server.cottongame.com/serverstore/service/logo.png' alt=''>
            <h3>CottonGame</h3>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="login-form">
            <el-form-item prop="account">
                <el-input size='medium' :placeholder="$t('login.enterAccount') || '请输入账号'"
                          v-model='ruleForm.account' />
            </el-form-item>
            <el-form-item prop="phone">
                <el-input size='medium' :placeholder="$t('login.enterPhone') || '请输入手机号'"
                          v-model='ruleForm.phone'>
                    <template slot="prepend">+86</template>
                </el-input>
            </el-form-item>
            <el-form-item prop="captcha">
                <el-input size='medium' style='width: 65%' :placeholder="$t('login.enterVerifyCode') || '请输入验证码'"
                          v-model='ruleForm.captcha' autocomplete='off' />
                &nbsp;&nbsp;<el-button type='text' :disabled='captcha.sendStatus' size='medium'
                                       @click='sendCaptchaByPhone' style='float: right'>
                {{ captcha.sendStatus ? `${captcha.resendTime}${$t('login.resendAfter') || '秒后重新获取'}` : $t('login.getVerifyCode') || '获取验证码' }}
            </el-button>
            </el-form-item>
            <el-form-item prop="password">
                <el-input size='medium' :placeholder="$t('login.enterPassword') || '请输入密码'" type='password'
                          show-password v-model='ruleForm.password' />
            </el-form-item>
            <el-form-item prop="duplicatePassword">
                <el-input size='medium' :placeholder="$t('register.reenterPassword') || '重新输入密码'" type='password'
                          show-password v-model='ruleForm.duplicatePassword' />
            </el-form-item>
            <el-form-item>
                <el-button size='medium' style='width: 100%' type='primary' @click='submitForm'>
                    {{ $t('login.createAccount') || '创建账号' }}
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="agreeUserProtocol">
                    <span>{{ $t('register.agreeAndRead') || '我已同意并阅读' }}</span>
                    &nbsp;<el-link :underline='false' type='primary' target='_blank'
                                   href='https://cottongame.com//Privacy/Web/privacy_cn.htm?initPage=2'>
                    {{ $t('register.userAgreement') || '用户协议、隐私政策' }}
                </el-link>
                </el-checkbox>
            </el-form-item>
            
            <el-divider content-position='center'>{{ $t('common.or') || '或者使用以下方式' }}</el-divider>
            <el-row :gutter='10'>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('emailRegister')">{{ $t('register.emailRegister') || '邮箱注册'
                        }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('login')">{{ $t('login.accountLogin') || '账号登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('phoneLogin')">{{ $t('login.phoneLogin') || '短信登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('emailLogin')">{{ $t('login.emailLogin') || '邮箱登录' }}
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { loginApi } from '@/service/api/loginApi';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';
import { accountApi } from '@/service/api/accountApi';

export default defineComponent({
    name: 'PhoneLogin',
    data() {
        let validateCaptcha = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterVerifyCode') || '请输入验证码'));
            } else {
                callback();
            }
        };
        let validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterPhone') || '请输入手机号'));
            } else {
                callback();
            }
        }
        
        let validateAccount = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterAccount') || '请输入账号'));
            } else {
                callback();
            }
        }
        
        let validatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterPassword') || '请输入密码'));
            } else {
                callback();
            }
        }
        
        let validateDuplicatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterPassword') || '请输入密码'));
            } else {
                if (value !== this.ruleForm.password) {
                    callback(new Error(this.$t('register.passwordDifferent') || '两次密码不同'));
                }
                callback();
            }
        }
        return {
            ruleForm: {
                phone: undefined,
                captcha: undefined,
                account: undefined,
                password: undefined,
                duplicatePassword: undefined
            },
            agreeUserProtocol: false,
            rules: {
                phone: [
                    { validator: validatePhone, trigger: 'blur' }
                ],
                captcha: [
                    { validator: validateCaptcha, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePassword, trigger: 'blur' }
                ],
                duplicatePassword: [
                    { validator: validateDuplicatePassword, trigger: 'blur' }
                ],
                account: [
                    { validator: validateAccount, trigger: 'blur' }
                ]
            },
            captcha: {
                sendStatus: false,
                resendTime: 60,
                time: undefined
            }
        };
    },
    created() {
        if (localStg.get(EnumLocalStore.jwtTokenName)) {
            this.$router.push('/')
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (!this.agreeUserProtocol) {
                        message.error(this.$t('register.pleaseAgree') || '请同意用户协议、隐私政策');
                        return false
                    }
                    // 判断是手机号还是账号
                    loginApi.registerAccountByPhoneOrEmail(this.ruleForm).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('register.registerSuccess') || '注册成功');
                            // 登录
                            loginApi.playerLogin(this.ruleForm).then(result => {
                                if (result.code === 200) {
                                    // 进入首页
                                    let data = result.data
                                    localStg.set(EnumLocalStore.jwtTokenName, data.token)
                                    localStg.set('account', data.data.account)
                                    localStg.set('userId', data.data.userId)
                                    localStg.set('platformId', data.data.platformId)
                                    this.$router.push('/')
                                }else {
                                    this.$router.push("/login")
                                }
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        sendCaptchaByPhone() {
            if (!this.ruleForm.phone) {
                return
            }
            accountApi.sendCaptchaByPhone({phone: this.ruleForm.phone}).then(result => {
                if (result.code === 200) {
                    message.success(this.$t('login.codeSentToPhone') || '验证码已发送至您的手机！');
                    this.captcha.sendStatus = true
                    this.captcha.time = setInterval(() => {
                        if (this.captcha.resendTime <= 1) {
                            clearInterval(this.captcha.time)
                            this.captcha.resendTime = 60
                            this.captcha.sendStatus = false
                        }
                        this.captcha.resendTime = this.captcha.resendTime - 1
                    }, 1000)
                }
            })
        },
        skipPage(router) {
            this.$router.push(router)
        }
    }
});
</script>

<style lang='css'>
@import "../../assets/css/login.css";
</style>
